
define('text!modules/overview/overview_template.html',[],function () { return '<div class="js-players-header"></div>\r\n<div class="js-players-list"></div>\r\n';});

